import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M31 8h-3V4.75a.752.752 0 0 0-.75-.75h-2.5a.752.752 0 0 0-.75.75V8h-8V4.75a.752.752 0 0 0-.75-.75h-2.5a.752.752 0 0 0-.75.75V8H9a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V11a3 3 0 0 0-3-3Zm-.375 25H9.375A.376.376 0 0 1 9 32.625V14h22v18.625a.376.376 0 0 1-.375.375Z" })
});
export default SvgCalendar;
